import React from 'react'
import './contact.css'
import call from './assets/call_icon.svg'
import location from './assets/location_icon.svg'
import mail from './assets/mail_icon.svg'

const Contact = () => {

    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
    
        formData.append("access_key", "b000b183-dc8f-4dea-9ae3-ddbf7d16bb7e");
    
        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);
    
        const res = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: json
        }).then((res) => res.json());
    
        if (res.success) {
          alert('Email sent succesfully')
        }
      };

    return (
        <div id='Contact'>
            <h1 className='heading'>GET IN TOUCH</h1>
            <div className='contact'>
                <div className='left-contact'> 
                    <h1>Let's Talk</h1>
                    <p>I,m currently available to take on new projects, so feel free to fill the form and message me to get your work done. </p>
                <div>
                <div className='contact-detail'>
                    <img src={mail} alt="raghavchandan1715@gmail.com" /><p>raghavchandan1715@gmail.com</p>
                </div>
                <div className='contact-detail'>
                    <img src={call} alt="7986554832" /><p>7986554832</p>
                </div>
                <div className='contact-detail'>
                    <img src={location} alt="Rupnagar, Punjab" /><p>Rupnagar, Punjab</p>
                    </div>
                </div>
                </div>

                <form onSubmit={onSubmit} className='form'>
                    <label htmlFor="">Your Name</label>
                    <input type="text" placeholder='Enter your name' name='name' required />
                    <label htmlFor="">Email ID</label>
                    <input type="text" placeholder='Enter your Email ID' name='email' required/>
                    <label htmlFor="">Write  your message here</label>
                    <textarea name="message" rows="8" placeholder='Message' required></textarea>
                    <button type='submit' className='contact-submit'>Submit Now</button>

                </form>
            </div>
        </div>
    )
}

export default Contact
